/* =========================================================
   TRENDWAY — PRODUCT THUMBS NATIVE SCROLL (DESKTOP) — FINAL
   - Destroy thumbs swiper (so it stops rewriting transforms)
   - Make thumbs wrapper native vertical scroll
   - Set thumbs height = MAIN GALLERY CONTAINER height (not img)
   - Click thumb => switch main media (swiper slideTo OR click by data-media-id)
========================================================= */
(function () {
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function isDesktop() { return window.matchMedia("(min-width: 990px)").matches; }

  // ---------- locate thumbs ----------
  function getThumbs() {
    const host = qs("swiper-product-thumbs");
    if (!host) return null;

    const swiperEl = qs(".swiper--product-thumbs", host) || qs(".swiper.swiper--product-thumbs", host) || qs(".swiper", host);
    if (!swiperEl) return null;

    const wrapper = qs(".swiper-wrapper", swiperEl);
    if (!wrapper) return null;

    return { host, swiperEl, wrapper };
  }

  // ---------- locate main gallery (big image) ----------
  function getMainGalleryRoot() {
    // include your custom elements + common theme wrappers
    const candidates = [
      "swiper-product-media",
      "swiper-product-main",
      ".swiper--product-media",
      ".swiper--product-main",
      ".main-product__media",
      ".media-gallery",
      ".product__media",
      ".main-product"
    ];
    for (const sel of candidates) {
      const el = qs(sel);
      if (el) return el;
    }
    return null;
  }

  function getMainSwiper() {
    const root = getMainGalleryRoot();
    if (!root) return null;

    // Try direct swiper element on/inside root
    const candidates = [
      root.classList && root.classList.contains("swiper") ? root : null,
      qs(".swiper--product-media", root),
      qs(".swiper--product-main", root),
      qs(".swiper", root)
    ].filter(Boolean);

    for (const el of candidates) {
      if (el && el.swiper) return el.swiper;
    }

    // fallback: find any swiper on page that is NOT thumbs
    const all = qsa(".swiper");
    for (const el of all) {
      if (el.closest && el.closest("swiper-product-thumbs")) continue;
      if (el.classList.contains("swiper--product-thumbs")) continue;
      if (el.swiper) return el.swiper;
    }
    return null;
  }

  // ---------- height: match thumbs to MAIN CONTAINER height (not img) ----------
  function getMainHeight() {
    const root = getMainGalleryRoot();
    if (!root) return 0;

    // Prefer the actual swiper container if exists (it represents the visible gallery area)
    const swiperContainer =
      qs(".swiper--product-media", root) ||
      qs(".swiper--product-main", root) ||
      (root.classList && root.classList.contains("swiper") ? root : null) ||
      qs(".swiper", root);

    const target = swiperContainer || root;
    const rect = target.getBoundingClientRect();
    let h = Math.round(rect.height);

    // guardrails
    if (!h || h < 240) h = Math.max(560, Math.round(window.innerHeight * 0.85));
    return Math.max(240, h - 2); // tiny trim prevents 1–2px clipping
  }

  function applyThumbsHeight(host) {
    const h = getMainHeight();
    host.style.display = "block";
    host.style.height = h + "px";
    host.style.maxHeight = h + "px";
    host.style.overflow = "hidden";
  }

  // ---------- make thumbs native scroll ----------
  function destroyThumbsSwiper(swiperEl) {
    const inst = swiperEl && swiperEl.swiper;
    if (inst && !inst.destroyed) {
      try { inst.destroy(true, false); } catch (e) {}
    }
  }

  function makeNativeScroll(host, swiperEl, wrapper) {
  // keep outer fixed
  swiperEl.style.height = "100%";
  swiperEl.style.maxHeight = "100%";
  swiperEl.style.overflow = "hidden";

  // we do NOT want scroll now
  wrapper.style.transform = "none";
  wrapper.style.transitionDuration = "0ms";
  wrapper.style.height = "100%";
  wrapper.style.maxHeight = "100%";
  wrapper.style.overflowY = "hidden";   // ✅ no scroll
  wrapper.style.overflowX = "hidden";
  wrapper.style.display = "flex";
  wrapper.style.flexDirection = "column";

  const GAP = 16;            // must match previous gap
  const COUNT = 6;           // ✅ always show 6
  const PAD_BOTTOM = 0;

  // compute exact thumb height so 6 items fit
  const hostH = host.getBoundingClientRect().height || 0;
  const usable = Math.max(0, hostH - PAD_BOTTOM - (GAP * (COUNT - 1)));
  const itemH = Math.max(40, Math.floor(usable / COUNT)); // min 40px safety

  wrapper.style.gap = GAP + "px";
  wrapper.style.paddingBottom = PAD_BOTTOM + "px";

  const slides = qsa(".swiper-slide", wrapper);

  slides.forEach(function (slide, i) {
    // show only first 6
    if (i < COUNT) {
      slide.style.display = "";
      slide.style.width = "100%";
      slide.style.height = itemH + "px";      // ✅ fixed height
      slide.style.margin = "0";
      slide.style.overflow = "hidden";
    } else {
      slide.style.display = "none";           // ✅ hide the rest
    }
  });

  // Make the thumb media fill the fixed slide height nicely
  slides.slice(0, COUNT).forEach(function (slide) {
    const media = qs(".media--thumb", slide) || slide;
    media.style.height = "100%";
    media.style.display = "flex";
    media.style.alignItems = "center";
    media.style.justifyContent = "center";

    const img = qs("img", slide);
    if (img) {
      img.style.width = "100%";
      img.style.height = "100%";
      img.style.objectFit = "contain";
      img.style.backgroundColor = "transparent";
      img.style.display = "block";
    }
  });

  // overlays must not eat clicks/wheel
  qsa(".media__overlay", host).forEach(function (el) {
    el.style.pointerEvents = "none";
  });
}


  // ---------- click thumb => change main media ----------
  function setActiveThumb(slideEl) {
    qsa("swiper-product-thumbs .swiper-slide").forEach(function (s) {
      s.classList.remove("swiper-slide-thumb-active");
      s.removeAttribute("data-selected");
    });
    if (slideEl) {
      slideEl.classList.add("swiper-slide-thumb-active");
      slideEl.setAttribute("data-selected", "");
      try { slideEl.scrollIntoView({ block: "nearest" }); } catch (e) {}
    }
  }

  function trySwitchMain(mediaId, indexGuess) {
    const mainSwiper = getMainSwiper();

    // 1) Swiper control (best)
    if (mainSwiper && mainSwiper.slides && mainSwiper.slides.length) {
      let target = -1;

      if (mediaId) {
        for (let i = 0; i < mainSwiper.slides.length; i++) {
          const s = mainSwiper.slides[i];
          const id = s && (s.getAttribute("data-media-id") || (s.dataset && s.dataset.mediaId));
          if (id && String(id) === String(mediaId)) { target = i; break; }
        }
      }

      if (target === -1 && Number.isFinite(indexGuess)) target = indexGuess;

      if (target >= 0) {
        try {
          if (typeof mainSwiper.slideToLoop === "function") mainSwiper.slideToLoop(target);
          else mainSwiper.slideTo(target);
          mainSwiper.update && mainSwiper.update();
          return true;
        } catch (e) {}
      }
    }

    // 2) Fallback: click matching media element inside main gallery
    const root = getMainGalleryRoot();
    if (root && mediaId) {
      const el = qs(`[data-media-id="${mediaId}"]`, root);
      if (el) {
        // Prefer a clickable child (img/button/a), else click the element itself
        const clickable = qs("button, a, img", el) || el;
        try { clickable.click(); return true; } catch (e) {}
      }
    }

    return false;
  }

  function bindThumbClicks(wrapper) {
    if (wrapper.__nativeBound) return;
    wrapper.__nativeBound = true;

    wrapper.addEventListener("click", function (e) {
      const slide = e.target.closest(".swiper-slide");
      if (!slide) return;

      const mediaId = slide.getAttribute("data-media-id") || (slide.dataset && slide.dataset.mediaId) || "";
      const idx = Number(slide.getAttribute("data-index"));

      // try switch main
      trySwitchMain(mediaId, Number.isFinite(idx) ? idx : undefined);

      // always highlight thumb
      setActiveThumb(slide);
    }, { passive: true });
  }

  // ---------- observer: keep height synced ----------
  let ro = null;
  function attachResizeObserver() {
    if (!("ResizeObserver" in window)) return;

    const root = getMainGalleryRoot();
    if (!root) return;

    // observe the actual visible gallery container if possible
    const observeTarget =
      qs(".swiper--product-media", root) ||
      qs(".swiper--product-main", root) ||
      (root.classList && root.classList.contains("swiper") ? root : null) ||
      root;

    if (!observeTarget) return;

    if (ro) ro.disconnect();
    ro = new ResizeObserver(function () {
      if (!isDesktop()) return;
      const thumbs = getThumbs();
      if (!thumbs) return;
      applyThumbsHeight(thumbs.host);
    });

    ro.observe(observeTarget);
  }

  // ---------- main runner ----------
  function run() {
    if (!isDesktop()) return;

    const thumbs = getThumbs();
    if (!thumbs) return;

    const { host, swiperEl, wrapper } = thumbs;

    destroyThumbsSwiper(swiperEl);
    applyThumbsHeight(host);
    makeNativeScroll(host, swiperEl, wrapper);
    bindThumbClicks(wrapper);
    attachResizeObserver();
  }

  function runWithRetries() {
    run();
    // retries because product media often lazy-loads
    let n = 0;
    const t = setInterval(function () {
      n += 1;
      run();
      if (n >= 14) clearInterval(t); // ~3.5s max
    }, 250);
  }

  document.addEventListener("DOMContentLoaded", runWithRetries);
  window.addEventListener("load", runWithRetries);

  window.addEventListener("resize", function () {
    if (!isDesktop()) return;
    clearTimeout(window.__thumbFixResizeT);
    window.__thumbFixResizeT = setTimeout(run, 120);
  });
})();
